import { useLocation } from '@reach/router';

export const useNavigationState = () => {
  const { state: navigationState, ...rest } = useLocation();
  return { navigationState, ...rest };
};
